import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const PayverseResultMob = () => {
  return <CommonResult />;
};

export default PayverseResultMob;
